/**
 * 手机端官网路由（与 PC 端 /、/WebGoods 等区分）
 */
export const H5 = {
    INDEX: '/H5Index',
    GOODS: '/H5WebGoods',
    ABOUT: '/H5WebAbout',
    NEWS: '/H5WebNews',
    SERVICE: '/H5Service',
    SOFT_DESC: '/H5SoftDesc',
    DIANSHANG: '/H5Dianshangtaizhang',
    SKETCH_PROJECT: '/H5SketchProject',
    SKETCH_CLIENT: '/H5SketchClient',
    SKETCH_LOGS: '/H5SketchLogs',
    XIAOFENG: '/H5Xiaofeng',
}

export function h5SoftDesc(id) {
    return id ? `${H5.SOFT_DESC}?id=${encodeURIComponent(id)}` : H5.SOFT_DESC
}

export function h5SketchProject(bxmId) {
    return bxmId ? `${H5.SKETCH_PROJECT}?bxm_id=${encodeURIComponent(bxmId)}` : H5.SKETCH_PROJECT
}

function toQuery(params) {
    const q = new URLSearchParams()
    if (params && typeof params === 'object') {
        Object.entries(params).forEach(([k, v]) => {
            if (v != null && v !== '') q.set(k, String(v))
        })
    }
    return q.toString()
}

export function h5SketchClient(params) {
    const s = toQuery(params)
    return s ? `${H5.SKETCH_CLIENT}?${s}` : H5.SKETCH_CLIENT
}

export function h5SketchLogs(params) {
    const s = toQuery(params)
    return s ? `${H5.SKETCH_LOGS}?${s}` : H5.SKETCH_LOGS
}
